.biel-chat-container {
  display: flex;
  flex-direction: column;
  height: var(--biel-chat-height);
  overflow-y: auto;
  padding: 10px;
  transition: all 0.3s ease-in-out;
}


.biel-chat-container--embedded {
  min-height: var(--biel-chat-embedded-height);
}

.biel-chat-container.sidebar-right,
.biel-chat-container.sidebar-left {
  height: calc(100vh - 200px);
}

.biel-chat-container.fullscreen {
  height: calc(100dvh - (180px + var(--biel-footer-font-size)));
  max-height: calc(100dvh - (180px + var(--biel-footer-font-size)));
}

.biel-chat-container::-webkit-scrollbar {
  width: 6px;
}

.biel-chat-container::-webkit-scrollbar-thumb {
  background-color: var(--biel-chat-scrollbar-color);
  border-radius: 10px;
  border: 3px solid transparent;
}

.biel-chat-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--biel-chat-scrollbar-hover-color);
}

.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-top: 10px;
}

.loading-animation .dot {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background-color: var(--biel-text-color);
  border-radius: 50%;
  animation: bounce 1.2s infinite ease-in-out;
}

.loading-animation .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-animation .dot:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-animation .dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.biel-continue-button-container {
  display: flex;
  margin-top: 10px;
}

.biel-continue-button {
  background-color: var(--biel-continue-button-bg-color);
  color: var(--biel-continue-button-color);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.biel-continue-button:hover {
  background-color: var(--biel-continue-button-bg-color-hover);
}